<template>
  <div
    :style="{
      position: 'relative',
      height: '80dvh'
    }"
  >
    <iframe
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        width: '100%',
        height: '100%'
      }"
      allowfullscreen="true"
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['currentLang', 'selectedBot']),
    src() {
      if (!this.currentLang) return ''
      return `https://agent-management.enterprise.zwiz.app/${this.currentLang}/agent-sale-performance-iframe`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'open_external_link') {
        window.open(event.data.url, '_blank')
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      } else if (event.data.event_id === 'redirect_to_all_in_one_chat') {
        const { search, app, inbox } = event.data.value
        let routeData = this.$router.resolve({
          name: 'livechat',
          path: '/' + this.currentLang + '/livechat',
          query: {
            userid: search,
            app: app,
            pageid: this.selectedBot.pageid
          }
        })
        if (this.selectedBot.features.includes('all-in-one-chat-new')) {
          routeData = this.$router.resolve({
            name: 'allinonechat-new',
            path: '/' + this.currentLang + '/allinonechat-new',
            query: {
              search: search,
              inbox: inbox,
              app: app
            }
          })
        }
        window.open(routeData.href, '_blank')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/AgentSalePerformance.vue